import {useState} from 'react';
import Container from 'react-bootstrap/Container';
import {Row, Col, Collapse} from 'react-bootstrap';
import {useLocation} from 'react-router-dom';
import IminioTextField from '../iminio_comps/fields/IminioTextField'
import IminioButton from '../iminio_comps/buttons/IminioButton'
import { iminioBackend } from '../../api/iminio_provider';


function LoginForm({ props }) {

    const currentRoute = useLocation()
    if (currentRoute.pathname === '/' || currentRoute.pathname === '/login'){
        require('../../styles/Login.css')
        document.body.style.background = 'var(--clr-orange-base)'
    }

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showError, setShowError] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const evalKeyDownSubmit = async (event) => {
        if(event.key==='Enter')
            sendLoginRequest()
    }

    const sendLoginRequest = async () => {
        setLoading(true)
        setShowError(false)
        await iminioBackend.login(email, password).then(data=>{
            window.location.assign("/dashboard")
        }).catch(err=>{
            setShowError(true)
            setLoading(false)
            console.log(err)
        })
    }

    return <> 
        <Container className={'sing-in-floating-container px-5 py-4'}>
            <Col className="animation-fade-in-up">
                <Row className="d-flex width-100 justify-content-center align-items-center">
                    <Col xs={8} className="d-flex justify-content-center align-items-center">
                        <div id="iminio-logo-login"></div>
                    </Col>
                </Row>
                <Row className="pt-3 justify-content-center align-items-center" xs={12}>
                    <IminioTextField placeholder="Email" disabled={isLoading} onChange={e=>setEmail(e.target.value)} onKeyUp={evalKeyDownSubmit}/>
                </Row>
                <Row className="pt-3 pb-3 justify-content-center align-items-center" xs={12}>
                    <IminioTextField placeholder="Password" type="password" disabled={isLoading} onChange={e=>setPassword(e.target.value)} onKeyUp={evalKeyDownSubmit}/>
                </Row>
                <Collapse in={showError}>
                    <Row className="justify-content-center">
                        <Col id="sing-in-error-container" className="bg-orange-dark d-flex justify-content-center align-items-center py-1">
                            <span className="fg-white justify-content-center">
                                E-mail o Password sbagliati
                            </span>
                        </Col>
                    </Row>
                </Collapse>
                <Row className="pt-3 justify-content-end" xs={12}>
                    <Col xs={6} md={4}>
                        <Row className="justify-content-end" xs={12}>
                            <IminioButton disabled={isLoading} loading={isLoading} color="bg-blue" textColor="fg-white" label="Login" onClick={sendLoginRequest}/>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Container>
    </>;
}

export default LoginForm